import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Stack } from '@mui/material';
import { MessageReaction } from '@vs-online-only-app/state';
import { ChatBubblePlacement } from './ChatBubble';

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isWindows = navigator.userAgent.includes('windows');

const safariStyles = css`
  font-size: 13px;
`;

const windowsStyles = css`
  font-size: 12px;
`;

const leftPlacement = css`
  right: -${({ theme }) => theme.spacing(1)};
`;

const rightPlacement = css`
  left: -${({ theme }) => theme.spacing(1)};
`;

const Container = styled(Stack)<{ $direction?: ChatBubblePlacement }>`
  position: absolute;
  bottom: -${({ theme }) => theme.spacing(1)};
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.background.paper};
  font-size: 16px;

  ${({ $direction }) => $direction === 'left' && leftPlacement}
  ${({ $direction }) => $direction === 'right' && rightPlacement}

  ${isSafari && safariStyles}
  ${isWindows && windowsStyles}
`;

const parseEmoji = (e: string) => String.fromCodePoint(parseInt(e, 16));

const renderEmoji = (emoji: string) => {
  const splittedEmoji = emoji.split(' ');
  const isRedHearthEmoji = splittedEmoji.length > 1;
  // Heart emoji is not rendered normally and always black in Safari, This way it became red
  const heartEmoji = (
    <span role="img" aria-label="red heart emoji">
      ❤️
    </span>
  );
  return isRedHearthEmoji ? heartEmoji : parseEmoji(emoji);
};

type Props = {
  reaction: MessageReaction;
  direction?: ChatBubblePlacement;
};

const EmojiReaction: FC<Props> = ({ reaction, direction }) => {
  if (!reaction.emoji) return null;
  return (
    <Container $direction={direction}>{renderEmoji(reaction.emoji)}</Container>
  );
};

export default EmojiReaction;
